import React from "react";
import {CSSTransition} from "react-transition-group";

import "./Modal.css";

const ModalOverlay = (props) => {
  return (
    <div className={`modal ${props.className}`} style={props.style}>
      <header className={`modal__header ${props.headerClass}`}>
        {props.header}
      </header>
      <form
        onSubmit={
          props.onSubmit ? props.onSubmit : (event) => event.preventDefault()
        }
      >
        <footer className={`modal__footer ${props.footerClass}`}>
          {props.footer}
        </footer>
      </form>
    </div>
  );
};

const Modal = (props) => {
  return (
    <>
      {props.show === true && (
        <div className={`modal_container`}>
          <CSSTransition
            in={props.show}
            mountOnEnter
            unmountOnExit
            timeout={200}
            classNames="modal"
          >
            <ModalOverlay {...props} />
          </CSSTransition>
        </div>
      )}
    </>
  );
};

export default Modal;
